import React, { useState } from 'react';
import { Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import { useTranslation } from 'react-i18next';
import { notificationStatuses } from '../../../../utils/constants';
import styles from './NotificationCard.module.scss';
import colors from '../../../../scss/colors';
import { ApproverCard } from './ApproverCard';
import { distanceDateFormat } from '../../../../utils/helpers';

const NotificationList = ({ items }) => {
  const { t } = useTranslation();
  const [cardToggle, setCardToggle] = useState(true);
  const [approverRowData, setApproverRowData] = useState('');
  const [labelText, setLabelText] = useState('');

  const clickHandlerContractor = (rowData) => {
    setApproverRowData(rowData);
    setCardToggle(false);
    if (rowData.Status === notificationStatuses(t).draft.apiStatus) {
      setLabelText(t('dashboard.cards.newapproveradded'));
    } else {
      setLabelText(t('dashboard.cards.newapprovercreated'));
    }
  };

  const renderRow = (item) => {
    if (item.type === 'contractor' && item.data) {
      return item.data?.length ? (
        item.data.map((row) => (
          <TableRow key={row.Id}>
            <TableCell sx={{ p: 1 }} align="left" onClick={() => clickHandlerContractor(row)}>
              <h5 className={styles.notificationLabel}>
                {row.Status === notificationStatuses(t).draft.apiStatus
                  ? t('dashboard.cards.newapproveradded')
                  : t('dashboard.cards.newapprovercreated')}
              </h5>
            </TableCell>
            <TableCell align="right" sx={{ color: colors.MEDIUM_GREY }}>
              <p>{distanceDateFormat(row.CreatedDate)}</p>
            </TableCell>
          </TableRow>
        ))
      ) : (
        <h5>{t('dashboard.cards.nonewnotification')}</h5>
      );
    }
    if (item.type === 'approver' && item.data) {
      return <h1>you can implement new table</h1>;
    }
    return null;
  };

  return cardToggle ? (
    [
      items?.length ? (
        <Typography className={styles.cardList}>
          <Table size="small" aria-label="a dense table">
            <TableBody>{items?.map((item) => renderRow(item))}</TableBody>
          </Table>
        </Typography>
      ) : (
        <h5>{t('dashboard.cards.nonewnotification')}</h5>
      )
    ]
  ) : (
    <ApproverCard setCardToggle={setCardToggle} approverRowData={approverRowData} labelText={labelText} />
  );
};

export default NotificationList;
